<script setup lang="ts">
const { setItems, productConfigurationSet } = useProductSetConfiguration();
</script>
<template>
  <div v-if="productConfigurationSet" class="pt-14 flex flex-col gap-4">
    <h4 class="mb:3 lg:mb-5 text-28px">
      {{ $t("product.detail.setConfiguration.productsForThisProject") }}
    </h4>
    <template v-for="productSetItem in setItems">
      <ProductDetailSetConfigurationItem :productSetItem="productSetItem" />
    </template>
  </div>
</template>
